<template>
  <div class="content__map__search-bar">
    <div class="input-wrapper">
      <div class="content__map__search-bar--input">
        <GMapAutocomplete placeholder="" required="true" @place_changed="setPlace"
          :options="{
            componentRestrictions: { country: 'pl' },
          }">
        </GMapAutocomplete>
        <label
          class="content__map__search-bar--label">{{ addressTranslate() }}</label>
        <CustomLoader v-if="userLocationPending" />
        <button title="use my location" class="my__location__btn"
          v-if="!userLocationPending" @click="setMyLocation">
          <img width="22" height="22" loading="lazy" class="gps-icon"
            :src="require('../assets/gps.png')" :alt="translateGPSIcon()" />
        </button>
      </div>
      <div class="content__map__search-bar--btn">
        <button title="Content search" class="base-button" @click="searchContent"
          :disabled="!searchedLocation.address">
          {{ findContentTranslate() }}
        </button>
      </div>
    </div>
    <p class="error" v-if="userLocationError">{{ userLocationError }}</p>
    <p class="contributors" v-if="userLocationSearched">&copy; <a
        href="https://www.openstreetmap.org/" target="_blank">OpenStreetMap</a>
      contributors</p>
  </div>
</template>

<script>
import { useContentStore } from "@/store/content";
import CustomLoader from "@/components/CustomLoader.vue";
import { ref } from "vue";
import axios from "axios";

export default {
  name: "ContentSearchBar",
  components: {
    CustomLoader
  },
  setup() {
    const store = useContentStore();
    const userLocationError = ref('');
    const userLocationSearched = ref(false);
    const searchedLocation = ref({});
    const userLocationPending = ref(false);
    function findContentTranslate() {
      const translations = {
        "agents": window.Drupal.t("Find agent"),
        "workshops": window.Drupal.t("Find workshop"),
      }
      return translations[store.contentType];
    }
    function addressTranslate() {
      return window.Drupal.t("Enter zip code or city");
    }
    function translateGPSIcon() {
      return window.Drupal.t("GPS icon");
    }
    function setMyLocation() {
      userLocationPending.value = true;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          axios
            .get(
              `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
            )
            .then((res) => {
              searchedLocation.value = {
                lat: +res.data.lat,
                lng: +res.data.lon,
                address: res.data.display_name,
              }
              document.querySelector(".pac-target-input").value =
                res.data.display_name;
              searchContent();
              userLocationError.value = "";
              userLocationSearched.value = true;
              userLocationPending.value = false;
            })
            .catch((err) => {
              console.log(err);
              userLocationSearched.value = true;
              userLocationPending.value = false;
            });
        },
        (error) => {
          console.log(error.message);
          userLocationError.value = window.Drupal.t("There was an error loading user location.");
          userLocationPending.value = false;
        }
      );
    }
    async function setPosition() {
      store.setSearchedLocation(searchedLocation.value);
      store.setCenterPosition({
        lat: searchedLocation.value.lat,
        lng: searchedLocation.value.lng,
      });
      store.zoomIn();
    }
    function searchContent() {
      setPosition();
      store.contentSearched = true;
      setTimeout(() => {
        store.showMapOverlay = store.getVisibleContents.length > 0 ? false : true;
      }, 100);
    }
    function setPlace(place) {
      searchedLocation.value = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        address: place.formatted_address,
      }
      userLocationError.value = "";
    }
    return {
      setMyLocation,
      store,
      searchContent,
      setPlace,
      searchedLocation,
      setPosition,
      findContentTranslate,
      addressTranslate,
      translateGPSIcon,
      userLocationError,
      userLocationSearched,
      userLocationPending
    };
  },
};
</script>

<style lang="scss" ></style>@/store/content